import React from 'react'
import { Box, Typography, Chip } from '@mui/material'
import { observer } from 'mobx-react-lite' // Добавляем observer для реактивности MobX

import statusStore from '../../../stores/statusStore'
import logger from '../../../utils/logger'

const RenderSelectedTags = observer(({ tags }) => {
	/* 	logger.log(`🎨 tags: ${JSON.stringify(tags)}`)
	logger.log(`🎨 objectId: ${objectId}`); */

	// Не отображаем теги, если объект принадлежит другому пользователю
	if (!tags || tags.length === 0) {
		return <></>
	}

	function hexToRgba(hex, alpha = 0.5) {
		// Проверяем, что hex существует
		if (!hex) return 'rgba(200, 200, 200, 0.5)' // Серый цвет по умолчанию
		
		let c = hex.replace('#', '')
		if (c.length === 3) {
			c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2]
		}
		const r = parseInt(c.slice(0, 2), 16)
		const g = parseInt(c.slice(2, 4), 16)
		const b = parseInt(c.slice(4, 6), 16)
		return `rgba(${r}, ${g}, ${b}, ${alpha})`
	}

	function getMe() {
		logger.log('tags: ', tags)
	}

	return (
		<Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
			
			{import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && <div onClick={() => logger.log('RenderSelectedTags Render')}>% RenderSelectedTags %</div>}

			<div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
				{tags.map(tag => {
					// Находим соответствующий тег в statusStore по id
					const storeTag = statusStore.tags.find(
						storeTag => storeTag.id === tag.id
					)
					
					// Если тег не найден в statusStore, пропускаем его
					if (!storeTag) return null
					
					// Используем цвет из storeTag
					const tagColor = storeTag.color

					return (
						<Chip
							key={tag.id}
							label={storeTag.name}
							size="small"
							sx={{
								backgroundColor: hexToRgba(tagColor, 0.6),
								borderRadius: '10px',
								height: 'auto',
								'& .MuiChip-label': {
									paddingY: 0.2,
									fontSize: '0.75rem',
								}
							}}
						/>
					)
				})}
			</div>
		</Box>
	)
})

export default RenderSelectedTags
